import { Switch, type SwitchProps as AntdSwitchProps, Popconfirm } from 'antd';
import { useField } from 'formik';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import FormItem, { type FormItemProps } from './FormItem';

export interface SwitchProps extends Omit<AntdSwitchProps, 'value'> {
    name: string;
    label?: string;
    required?: boolean;
    tooltip?: FormItemProps['tooltip'];
    confirmTitle?: string;
}

const ConfirmSwitchField = ({ name, required, label, tooltip, confirmTitle, onChange, ...props }: SwitchProps) => {
    const { t } = useTranslation(['common']);
    const [field, meta, helpers] = useField({ name });

    return (
        <FormItem label={label} meta={meta} name={name} required={required} tooltip={tooltip}>
            <Popconfirm
                onConfirm={() => {
                    helpers.setValue(!field.value);
                    onChange(!field.value, undefined);
                }}
                title={confirmTitle || t('common:messages.switchConfirm')}
            >
                <Switch
                    checked={field.value}
                    // spread props
                    {...props}
                />
            </Popconfirm>
        </FormItem>
    );
};

export default memo(ConfirmSwitchField);
